<template>
    <div id="infos">
        <h2>Resource Information</h2>
        <div class="info-group" v-for="info in infoGroups" v-bind:key="info.idInfo">
            <span class="info-description">{{info.infoDescription}}</span>
            <ul>
                <li v-for="option in info.options" v-bind:key="option.idInfoOption">
                    <span v-show="option.optionTitle">{{option.optionTitle}}</span>
                    <span v-show="option.otherValue">{{option.otherValue}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        name: "Infos",
        props: {
            infos: Array
        },
        computed: {
            infoGroups (){
                let ig = [];
                let groups = _.groupBy(this.infos, 'idInfo');

                Object.keys(groups).forEach(idInfo => {
                    let currInfos = groups[idInfo];
                    let thisInfo = {idInfo: idInfo};

                    thisInfo.infoTitle = currInfos[0].infoTitle;
                    thisInfo.infoDescription = currInfos[0].infoDescription;
                    thisInfo.options = currInfos;

                    ig.push(thisInfo);
                });

                return ig;
            }
        }
    }
</script>

<style scoped>

</style>